import React, { useRef, useState, useCallback } from 'react'
import styled from 'styled-components'
import Button from './Button'
import Box from './Box'
import SvgSearchIcon from 'assets/icons/Search'
import useClickOutside from 'shared/hooks/useClickOutside'

interface SearchFieldType {
  id?: string
  value?: string
  placeholder?: string
  onChange: Function
  color?: string
}

const SearchField: React.FC<SearchFieldType> = (props: SearchFieldType) => {
  const { id, value, placeholder, onChange, color } = props

  const [showTextField, setShowTextField] = useState(false)

  const fieldRef = useRef<HTMLDivElement>(null)
  const inputRef = useRef<HTMLInputElement>(null)

  useClickOutside(fieldRef, () => inputRef.current?.value === '' && setShowTextField(false))

  const toggleField = useCallback(() => {
    if (showTextField && inputRef.current?.value !== '') return

    setShowTextField(!showTextField)

    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus()
      }
    }, 600)
  }, [showTextField, inputRef, setShowTextField])

  return (
    <SearchFieldContainer $showTextField={showTextField} ref={fieldRef}>
      <Button px="0px" onClick={toggleField}>
        <SvgSearchIcon fill={color} />
      </Button>
      {showTextField && (
        <StyledTextField
          id={id}
          type="text"
          ref={inputRef}
          placeholder={placeholder}
          value={value}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        />
      )}
    </SearchFieldContainer>
  )
}

const SearchFieldContainer = styled(Box)<{ $showTextField: boolean }>`
  width: 22px;
  height: 46px;
  transition: width 0.3s ease-in-out;

  ${({ $showTextField, theme }) =>
    $showTextField &&
    `
    width: 250px;
    border-bottom: 2px solid ${theme.colors.border};
    display: flex;
  `}
`

const StyledTextField = styled.input`
  border: none;
  outline: 0;
  margin-left: 12px;
  font-size: 16px;
  font-weight: 500;
  caret-color: #1573ff;
  width: 100%;

  &::placeholder {
    color: #c6c6c6;
  }
`

export default SearchField
